const OUT = "#4A2511";

const rr = (ctx, x, y, w, h, r) => { ctx.beginPath(); ctx.roundRect(x, y, w, h, r); };
const ell = (ctx, x, y, rx, ry) => { ctx.beginPath(); ctx.ellipse(x, y, Math.max(0.1, rx), Math.max(0.1, ry), 0, 0, Math.PI * 2); };

// stroke every shape first, then fill, so overlapping parts merge into one outlined silhouette
const blobShape = (ctx, shapes, fill, lw, stroke = OUT) => {
  ctx.lineWidth = lw; ctx.strokeStyle = stroke; ctx.lineJoin = "round";
  shapes.forEach((s) => { s(); ctx.stroke(); });
  ctx.fillStyle = fill;
  shapes.forEach((s) => { s(); ctx.fill(); });
};

const shadow = (ctx, x, y, w) => {
  ctx.fillStyle = "rgba(74,37,17,0.22)";
  ell(ctx, x, y, w, w * 0.22); ctx.fill();
};

const eyes = (ctx, x, y, gap, ang, size, angry = false, white = "#fff") => {
  const lx = Math.cos(ang) * size * 0.35, ly = Math.sin(ang) * size * 0.35;
  [-gap, gap].forEach((dx, i) => {
    ctx.fillStyle = white; ctx.strokeStyle = OUT; ctx.lineWidth = 1.5;
    ell(ctx, x + dx, y, size, size * 1.15); ctx.fill(); ctx.stroke();
    ctx.fillStyle = "#1A0E07";
    ell(ctx, x + dx + lx, y + ly, size * 0.5, size * 0.6); ctx.fill();
    ctx.fillStyle = "#fff";
    ell(ctx, x + dx + lx - size * 0.2, y + ly - size * 0.25, size * 0.16, size * 0.16); ctx.fill();
    if (angry) {
      ctx.strokeStyle = OUT; ctx.lineWidth = 2.5; ctx.beginPath();
      const s = i ? -1 : 1;
      ctx.moveTo(x + dx - size * s, y - size * 1.5); ctx.lineTo(x + dx + size * 0.8 * s, y - size * 0.9); ctx.stroke();
    }
  });
};

export const drawToast = (ctx, x, y, s = 22, buttered = false) => {
  const w = s / 2, h = s / 2;
  shadow(ctx, x, y + h + 5, w * 0.9);
  const shapes = [
    () => rr(ctx, x - w, y - h * 0.35, w * 2, h * 1.35, s * 0.14),
    () => ell(ctx, x - w * 0.42, y - h * 0.35, w * 0.62, h * 0.62),
    () => ell(ctx, x + w * 0.42, y - h * 0.35, w * 0.62, h * 0.62),
  ];
  blobShape(ctx, shapes, "#C46F24", Math.max(2, s * 0.09));
  ctx.save(); ctx.translate(x, y + h * 0.05); ctx.scale(0.78, 0.78); ctx.translate(-x, -y - h * 0.05);
  const g = ctx.createLinearGradient(x, y - h, x, y + h);
  g.addColorStop(0, "#FFE9AE"); g.addColorStop(1, "#F2C46E");
  shapes.forEach((sh) => { sh(); ctx.fillStyle = g; ctx.fill(); });
  ctx.restore();
  if (buttered) { ctx.fillStyle = "#FFE45C"; rr(ctx, x - w * 0.45, y - h * 0.3, w * 0.9, h * 0.7, 3); ctx.fill(); }
  ctx.fillStyle = "rgba(255,255,255,0.7)";
  ell(ctx, x - w * 0.45, y - h * 0.5, w * 0.18, h * 0.12); ctx.fill();
};

export const drawHeart = (ctx, x, y, s = 20) => {
  const k = s / 20;
  ctx.save(); ctx.translate(x, y); ctx.scale(k, k);
  ctx.beginPath();
  ctx.moveTo(0, 7); ctx.bezierCurveTo(-14, -2, -9, -14, 0, -6); ctx.bezierCurveTo(9, -14, 14, -2, 0, 7);
  ctx.fillStyle = "#F43F5E"; ctx.fill(); ctx.lineWidth = 2; ctx.strokeStyle = OUT; ctx.stroke();
  ctx.fillStyle = "rgba(255,255,255,0.7)"; ell(ctx, -5, -6, 2.5, 1.8); ctx.fill();
  ctx.restore();
};

const SKINS = {
  chef_hat: (ctx, x, y) => {
    blobShape(ctx, [() => rr(ctx, x - 10, y - 22, 20, 9, 2), () => ell(ctx, x - 7, y - 27, 7, 7), () => ell(ctx, x + 7, y - 27, 7, 7), () => ell(ctx, x, y - 31, 8, 7)], "#FFFFFF", 2);
  },
  knight_armor: (ctx, x, y) => {
    blobShape(ctx, [() => rr(ctx, x - 16, y - 20, 32, 12, [10, 10, 2, 2])], "#B8C4D6", 2);
    ctx.fillStyle = "#475569"; ctx.fillRect(x - 11, y - 12, 22, 3);
    blobShape(ctx, [() => ell(ctx, x, y - 25, 3, 7)], "#EF4444", 1.5);
    blobShape(ctx, [() => rr(ctx, x - 12, y + 11, 24, 8, 3)], "#CBD5E1", 2);
  },
  pirate_hat: (ctx, x, y) => {
    blobShape(ctx, [() => ell(ctx, x, y - 16, 19, 5), () => rr(ctx, x - 11, y - 28, 22, 13, [8, 8, 0, 0])], "#1F2937", 2);
    ctx.fillStyle = "#F8FAFC"; ell(ctx, x, y - 22, 3, 3); ctx.fill();
  },
  wizard_hat: (ctx, x, y) => {
    blobShape(ctx, [() => ell(ctx, x, y - 13, 17, 4.5), () => { ctx.beginPath(); ctx.moveTo(x - 11, y - 14); ctx.quadraticCurveTo(x - 2, y - 30, x + 8, y - 42); ctx.quadraticCurveTo(x + 4, y - 28, x + 11, y - 14); ctx.closePath(); }], "#7C3AED", 2);
    ctx.fillStyle = "#FDE047"; [[-3, -22, 2.2], [3, -30, 1.6], [-6, -16, 1.4]].forEach(([dx, dy, r]) => { ell(ctx, x + dx, y + dy, r, r); ctx.fill(); });
  },
  royal_crown: (ctx, x, y) => {
    blobShape(ctx, [() => { ctx.beginPath(); ctx.moveTo(x - 10, y - 13); ctx.lineTo(x - 11, y - 25); ctx.lineTo(x - 5, y - 19); ctx.lineTo(x, y - 28); ctx.lineTo(x + 5, y - 19); ctx.lineTo(x + 11, y - 25); ctx.lineTo(x + 10, y - 13); ctx.closePath(); }], "#FBBF24", 2);
    ctx.fillStyle = "#EF4444"; ell(ctx, x, y - 16, 2.2, 2.2); ctx.fill();
    ctx.fillStyle = "#3B82F6"; ell(ctx, x - 6, y - 16, 1.6, 1.6); ctx.fill(); ell(ctx, x + 6, y - 16, 1.6, 1.6); ctx.fill();
  },
  cowboy_hat: (ctx, x, y) => {
    blobShape(ctx, [() => ell(ctx, x, y - 13, 21, 4.5), () => rr(ctx, x - 10, y - 27, 20, 14, [7, 7, 1, 1])], "#A16207", 2);
    ctx.fillStyle = "#451A03"; ctx.fillRect(x - 10, y - 18, 20, 3);
  },
  viking_helmet: (ctx, x, y) => {
    [-1, 1].forEach((sd) => blobShape(ctx, [() => { ctx.beginPath(); ctx.moveTo(x + sd * 9, y - 17); ctx.quadraticCurveTo(x + sd * 20, y - 20, x + sd * 18, y - 32); ctx.quadraticCurveTo(x + sd * 14, y - 24, x + sd * 7, y - 22); ctx.closePath(); }], "#F8FAFC", 2));
    blobShape(ctx, [() => { ctx.beginPath(); ctx.arc(x, y - 12, 12, Math.PI, 0); ctx.closePath(); }], "#94A3B8", 2);
    ctx.fillStyle = "#64748B"; ctx.fillRect(x - 12, y - 14, 24, 3); ctx.fillRect(x - 1.5, y - 24, 3, 10);
  },
  ninja_mask: (ctx, x, y) => { ctx.fillStyle = "#1E293B"; rr(ctx, x - 11, y + 6, 22, 7, 2); ctx.fill(); ctx.fillStyle = "#334155"; ctx.fillRect(x - 11, y + 7, 22, 1.5); },
  superhero_cape: (ctx, x, y) => { ctx.fillStyle = "#FDE047"; ctx.strokeStyle = OUT; ctx.lineWidth = 1.5; ell(ctx, x, y + 14, 4.5, 3.5); ctx.fill(); ctx.stroke(); ctx.fillStyle = "#DC2626"; ctx.font = 'bold 6px sans-serif'; ctx.textAlign = "center"; ctx.fillText("B", x, y + 16); },
  cool_shades: (ctx, x, y) => {
    ctx.fillStyle = "#111827";
    rr(ctx, x - 13, y - 7, 11, 7, 3); ctx.fill(); rr(ctx, x + 2, y - 7, 11, 7, 3); ctx.fill(); ctx.fillRect(x - 3, y - 6, 6, 2);
    ctx.fillStyle = "rgba(125,211,252,0.8)"; ctx.fillRect(x - 11, y - 6, 3, 2); ctx.fillRect(x + 4, y - 6, 3, 2);
  },
};

const HEADBAND = { chef_hat: "#F8FAFC", knight_armor: "#64748B", pirate_hat: "#111827", cool_shades: "#F97316", wizard_hat: "#7C3AED", royal_crown: "#FBBF24", cowboy_hat: "#92400E", viking_helmet: "#475569", ninja_mask: "#0F172A", superhero_cape: "#2563EB" };
const SKIN_BACK = {
  superhero_cape: (ctx, x, y, dir, t) => {
    const w = Math.sin(t * 9) * 3;
    blobShape(ctx, [() => { ctx.beginPath(); ctx.moveTo(x - 9, y - 16); ctx.lineTo(x + 9, y - 16); ctx.quadraticCurveTo(x - dir * 4, y + 4, x - dir * 20 + w, y + 12); ctx.lineTo(x - dir * 25 + w, y - 1); ctx.closePath(); }], "#DC2626", 2);
  },
};
const SKIN_DY = { cool_shades: -3, ninja_mask: -10 };

const limb = (ctx, x1, y1, x2, y2, color) => {
  ctx.lineCap = "round";
  ctx.strokeStyle = OUT; ctx.lineWidth = 5; ctx.beginPath(); ctx.moveTo(x1, y1); ctx.lineTo(x2, y2); ctx.stroke();
  ctx.strokeStyle = color; ctx.lineWidth = 2.2; ctx.beginPath(); ctx.moveTo(x1, y1); ctx.lineTo(x2, y2); ctx.stroke();
};
const glove = (ctx, x, y) => { ctx.fillStyle = "#FFFFFF"; ctx.strokeStyle = OUT; ctx.lineWidth = 1.8; ell(ctx, x, y, 3.4, 3.4); ctx.fill(); ctx.stroke(); };

export const drawHero = (ctx, p, t, happy = false, skin = null) => {
  const { x, y } = p, dir = p.dir || 1;
  const step = Math.sin((p.walk || 0) * 16);
  const air = p.onGround === false ? Math.max(-0.12, Math.min(0.12, (p.vy || 0) / -3000)) : 0;
  const bob = p.onGround === false ? 0 : Math.abs(step) * 1.2;
  const band = HEADBAND[skin] || "#E11D48";
  shadow(ctx, x, y + 15, 12);
  // back arm, legs and boots
  limb(ctx, x - dir * 9, y - 4 - bob, x - dir * 14, y + 3 - step * 3 - bob, "#F2B705");
  glove(ctx, x - dir * 14, y + 3 - step * 3 - bob);
  [[-1, step], [1, -step]].forEach(([side, s]) => {
    const fx = x + side * 5 + s * 4, fy = y + 12 - Math.max(0, s) * 2;
    limb(ctx, x + side * 5, y + 6, fx, fy, "#F2B705");
    blobShape(ctx, [() => rr(ctx, fx - 4 + dir * 1.5, fy - 1, 9, 5, [3, 3, 2, 2])], "#7C3F16", 1.8);
  });
  ctx.save(); ctx.translate(x, y - bob + 8); ctx.scale(1 - air, 1 + air); ctx.translate(-x, -y - 8);
  // headband tails flutter behind
  const tw = Math.sin(t * 14) * 3;
  ctx.strokeStyle = OUT; ctx.lineWidth = 5; ctx.lineCap = "round";
  ctx.beginPath(); ctx.moveTo(x - dir * 10, y - 14); ctx.quadraticCurveTo(x - dir * 17, y - 17 + tw, x - dir * 22, y - 12 + tw); ctx.stroke();
  ctx.strokeStyle = band; ctx.lineWidth = 2.6; ctx.stroke();
  if (SKIN_BACK[skin]) SKIN_BACK[skin](ctx, x, y, dir, t);
  // butter stick body
  const g = ctx.createLinearGradient(x - 11, 0, x + 11, 0);
  g.addColorStop(0, "#FFE680"); g.addColorStop(0.55, "#FFD43B"); g.addColorStop(1, "#F2B705");
  blobShape(ctx, [() => rr(ctx, x - 11, y - 22, 22, 30, 6)], g, 3);
  ctx.fillStyle = "#FFF3B0"; rr(ctx, x - 9, y - 20, 18, 4, 3); ctx.fill();
  ctx.fillStyle = "#FFE680"; ell(ctx, x + 6, y - 17, 2.4, 3.4); ctx.fill();
  ctx.fillStyle = "rgba(255,255,255,0.6)"; rr(ctx, x - 8, y - 13, 2.5, 11, 2); ctx.fill();
  // paper wrapper
  ctx.fillStyle = "#FFFBEB"; rr(ctx, x - 9.5, y + 2, 19, 5, [0, 0, 4, 4]); ctx.fill();
  ctx.fillStyle = "#DC2626"; ctx.fillRect(x - 9.5, y + 3.5, 19, 1.6);
  // headband
  ctx.fillStyle = band; ctx.fillRect(x - 10.5, y - 16, 21, 4);
  ctx.fillStyle = "rgba(255,255,255,0.35)"; ctx.fillRect(x - 10.5, y - 16, 21, 1.2);
  // face
  const ex = x + dir * 2;
  if (happy) {
    ctx.strokeStyle = OUT; ctx.lineWidth = 2.5;
    [-4.8, 4.8].forEach((d) => { ctx.beginPath(); ctx.arc(ex + d, y - 6, 3, Math.PI, 0); ctx.stroke(); });
  } else {
    eyes(ctx, ex, y - 6, 4.8, dir > 0 ? 0 : Math.PI, 3.2);
    ctx.strokeStyle = OUT; ctx.lineWidth = 2; ctx.lineCap = "round";
    [-1, 1].forEach((s) => { ctx.beginPath(); ctx.moveTo(ex + s * 7.5, y - 11.5); ctx.lineTo(ex + s * 2.5, y - 10.5); ctx.stroke(); });
  }
  ctx.fillStyle = "rgba(244,114,182,0.6)";
  ell(ctx, ex - 8, y - 1.5, 2.4, 1.6); ctx.fill(); ell(ctx, ex + 8, y - 1.5, 2.4, 1.6); ctx.fill();
  ctx.strokeStyle = OUT; ctx.lineWidth = 2;
  if (happy) { ctx.fillStyle = "#7F1D1D"; ctx.beginPath(); ctx.arc(ex, y - 1.5, 3.5, 0, Math.PI); ctx.closePath(); ctx.fill(); ctx.stroke(); }
  else { ctx.beginPath(); ctx.arc(ex + dir, y - 2, 2.6, 0.2, Math.PI - 0.6); ctx.stroke(); }
  if (skin && SKINS[skin]) SKINS[skin](ctx, x, y + (SKIN_DY[skin] ?? -10));
  ctx.restore();
  // front arm reaching for the weapon
  limb(ctx, x + dir * 8, y - 4 - bob, x + dir * 12, y - 6 - bob, "#F2B705");
  glove(ctx, x + dir * 12, y - 6 - bob);
};

const CRUMB_PTS = [1, 0.82, 1.05, 0.9, 1, 0.78, 0.98, 0.88, 1.04, 0.86];
const radial = (ctx, x, y, r, c1, c2) => {
  const g = ctx.createRadialGradient(x - r * 0.35, y - r * 0.45, r * 0.1, x, y, r * 1.25);
  g.addColorStop(0, c1); g.addColorStop(1, c2);
  return g;
};
const feet = (ctx, x, y, r, t, color, seed = 0) => {
  const s = Math.sin(t * 12 + seed) * r * 0.25;
  ctx.fillStyle = color; ctx.strokeStyle = OUT; ctx.lineWidth = 1.5;
  ell(ctx, x - r * 0.45 + s, y + r * 0.95, r * 0.32, r * 0.18); ctx.fill(); ctx.stroke();
  ell(ctx, x + r * 0.45 - s, y + r * 0.95, r * 0.32, r * 0.18); ctx.fill(); ctx.stroke();
};
const mouth = (ctx, x, y, w, teeth = true) => {
  ctx.fillStyle = "#3B0F0F"; ctx.strokeStyle = OUT; ctx.lineWidth = 1.5;
  ctx.beginPath(); ctx.moveTo(x - w, y); ctx.quadraticCurveTo(x, y + w * 0.9, x + w, y); ctx.closePath(); ctx.fill(); ctx.stroke();
  if (teeth) { ctx.fillStyle = "#fff"; ctx.fillRect(x - w * 0.6, y, w * 0.35, w * 0.3); ctx.fillRect(x + w * 0.25, y, w * 0.35, w * 0.3); }
};
const legsLines = (ctx, x, y, r, t, n, color) => {
  ctx.strokeStyle = color; ctx.lineWidth = 2; ctx.lineCap = "round";
  for (let i = 0; i < n; i++) {
    const side = i % 2 ? 1 : -1, k = Math.floor(i / 2), sw = Math.sin(t * 14 + i) * 3;
    ctx.beginPath(); ctx.moveTo(x + side * r * 0.5, y + r * 0.2 + k * 3); ctx.lineTo(x + side * (r * 1.1 + sw), y + r * 0.85 + k * 2); ctx.stroke();
  }
};

export const drawEnemy = (ctx, e, t, ang) => {
  const flash = e.hitT > 0;
  const { x, y, r } = e;
  const F = (c) => (flash ? "#ffffff" : c);
  if (e.type !== "ghost" && e.type !== "bee") shadow(ctx, x, y + r + 2, r);
  if (e.type === "crumb") {
    feet(ctx, x, y, r, t, "#7A3E0E", e.seed);
    blobShape(ctx, [() => {
      ctx.beginPath();
      CRUMB_PTS.forEach((k, i) => { const a = (i / CRUMB_PTS.length) * Math.PI * 2; ctx.lineTo(x + Math.cos(a) * r * k * 1.1, y + Math.sin(a) * r * k); });
      ctx.closePath();
    }], F(radial(ctx, x, y, r, "#E39A4C", "#9A4F12")), 2.5);
    ctx.fillStyle = "#7A3E0E";
    [[-0.5, 0.45, 2.2], [0.55, 0.35, 1.7], [0.1, 0.6, 1.4], [-0.2, -0.65, 1.5]].forEach(([dx, dy, s]) => { ell(ctx, x + dx * r, y + dy * r, s, s); ctx.fill(); });
    eyes(ctx, x, y - r * 0.2, r * 0.38, ang, r * 0.25, true);
    mouth(ctx, x, y + r * 0.3, r * 0.35);
    const sw = Math.sin(t * 10 + (e.seed || 0)) * r * 0.25;
    ctx.strokeStyle = OUT; ctx.lineWidth = 2; ctx.lineCap = "round";
    [-1, 1].forEach((sd) => { ctx.beginPath(); ctx.moveTo(x + sd * r * 0.95, y + r * 0.1); ctx.lineTo(x + sd * r * 1.45, y - r * 0.2 + sd * sw); ctx.stroke(); });
    ctx.fillStyle = "rgba(255,255,255,0.3)"; ell(ctx, x - r * 0.4, y - r * 0.55, r * 0.3, r * 0.14); ctx.fill();
  } else if (e.type === "jam") {
    const sq = 1 + Math.sin(t * 10 + (e.seed || 0)) * 0.12;
    blobShape(ctx, [() => ell(ctx, x, y + (1 - sq) * r * 0.5, r * sq, r / sq), () => ell(ctx, x - r * 0.5, y + r * 0.85, r * 0.2, r * 0.3), () => ell(ctx, x + r * 0.4, y + r * 0.9, r * 0.15, r * 0.25)], F(radial(ctx, x, y, r, "#D8B4FE", "#6B21A8")), 2.5);
    ctx.fillStyle = "rgba(255,255,255,0.8)"; ell(ctx, x - r * 0.4, y - r * 0.45, r * 0.28, r * 0.16); ctx.fill(); ell(ctx, x + r * 0.45, y - r * 0.2, r * 0.08, r * 0.08); ctx.fill();
    ctx.fillStyle = "rgba(76,29,149,0.6)"; ell(ctx, x + r * 0.2, y + r * 0.3, r * 0.14, r * 0.1); ctx.fill();
    eyes(ctx, x, y - r * 0.1, r * 0.36, ang, r * 0.24);
    mouth(ctx, x, y + r * 0.35, r * 0.25, false);
    ctx.fillStyle = F("#7E22CE");
    [[-0.7, 0], [0.75, 1.3]].forEach(([dx, ph]) => { const d = (Math.sin(t * 3 + ph) + 1) * r * 0.18; ell(ctx, x + dx * r, y + r * 0.75 + d, r * 0.1, r * 0.16 + d * 0.3); ctx.fill(); });
  } else if (e.type === "mold") {
    const fuzz = [];
    for (let i = 0; i < 11; i++) { const a = (i / 11) * Math.PI * 2 + t * 0.4; fuzz.push(() => ell(ctx, x + Math.cos(a) * r * 0.85, y + Math.sin(a) * r * 0.85, r * 0.32, r * 0.32)); }
    blobShape(ctx, [() => ell(ctx, x, y, r, r), ...fuzz], F(radial(ctx, x, y, r, "#86EFAC", "#047857")), 2.5);
    ctx.fillStyle = "#065F46";
    [[-0.45, 0.4, 0.18], [0.5, 0.2, 0.13], [0.15, 0.6, 0.1], [-0.6, -0.3, 0.1]].forEach(([dx, dy, s]) => { ell(ctx, x + dx * r, y + dy * r, r * s, r * s * 0.8); ctx.fill(); });
    ctx.fillStyle = "rgba(167,243,208,0.8)";
    for (let i = 0; i < 4; i++) { const a = t * 1.5 + i * 1.6; ell(ctx, x + Math.cos(a) * r * 1.5, y - r * 0.3 + Math.sin(a * 1.3) * r * 0.8, 2, 2); ctx.fill(); }
    eyes(ctx, x, y - r * 0.2, r * 0.38, ang, r * 0.25, false, "#ECFDF5");
    mouth(ctx, x, y + r * 0.35, r * 0.3);
  } else if (e.type === "turret") {
    const g = ctx.createLinearGradient(x - r, y, x + r, y);
    g.addColorStop(0, "#94A3B8"); g.addColorStop(0.5, "#F8FAFC"); g.addColorStop(1, "#64748B");
    ctx.fillStyle = "#334155"; ctx.fillRect(x - r * 0.9, y + r * 0.8, r * 0.35, r * 0.3); ctx.fillRect(x + r * 0.55, y + r * 0.8, r * 0.35, r * 0.3);
    blobShape(ctx, [() => rr(ctx, x - r * 1.1, y - r * 0.85, r * 2.2, r * 1.75, r * 0.4)], F(g), 2.5);
    ctx.fillStyle = "#475569"; rr(ctx, x + r * 1.05, y - r * 0.3, r * 0.3, r * 0.6, 2); ctx.fill();
    const hot = (e.fireT || 1) < 0.4;
    ctx.fillStyle = hot ? "#FB923C" : "#7F1D1D"; if (hot) { ctx.shadowColor = "#FB923C"; ctx.shadowBlur = 10; }
    rr(ctx, x - r * 0.75, y - r * 0.85, r * 0.6, r * 0.25, 2); ctx.fill(); rr(ctx, x + r * 0.15, y - r * 0.85, r * 0.6, r * 0.25, 2); ctx.fill();
    ctx.shadowBlur = 0;
    eyes(ctx, x, y + r * 0.0, r * 0.42, ang, r * 0.2, true, "#FEE2E2");
    ctx.fillStyle = "#1F2937"; rr(ctx, x - r * 0.4, y + r * 0.45, r * 0.8, r * 0.18, 2); ctx.fill();
  } else if (e.type === "ghost") {
    ctx.globalAlpha = 0.88;
    blobShape(ctx, [() => {
      ctx.beginPath(); ctx.moveTo(x - r, y + r * 0.7); ctx.lineTo(x - r, y - r * 0.2); ctx.arc(x, y - r * 0.2, r, Math.PI, 0); ctx.lineTo(x + r, y + r * 0.7);
      for (let i = 0; i < 4; i++) ctx.quadraticCurveTo(x + r - (i + 0.5) * (r / 2), y + r * (Math.sin(t * 8 + i) > 0 ? 1.2 : 0.8), x + r - (i + 1) * (r / 2), y + r * 0.7);
      ctx.closePath();
    }], F(radial(ctx, x, y, r, "#6B4A36", "#1F140D")), 2.5, "#120B07");
    ctx.globalAlpha = 1;
    ctx.fillStyle = "rgba(251,146,60,0.7)"; for (let i = 0; i < 3; i++) { ell(ctx, x - r * 0.6 + i * r * 0.6, y - r * 1.1 - ((t * 20 + i * 7) % 10), 1.6, 1.6); ctx.fill(); }
    ctx.shadowColor = "#FDE047"; ctx.shadowBlur = 8;
    eyes(ctx, x, y - r * 0.2, r * 0.36, ang, r * 0.24, true, "#FDE047");
    ctx.shadowBlur = 0;
    mouth(ctx, x, y + r * 0.35, r * 0.3);
  } else if (e.type === "bee") {
    const flap = Math.abs(Math.sin(t * 30));
    ctx.fillStyle = "rgba(224,242,254,0.75)"; ctx.strokeStyle = "rgba(74,37,17,0.5)"; ctx.lineWidth = 1;
    ell(ctx, x - r * 0.3, y - r * 0.9, r * 0.5, r * 0.8 * flap + 1); ctx.fill(); ctx.stroke();
    ell(ctx, x + r * 0.35, y - r * 0.9, r * 0.45, r * 0.7 * flap + 1); ctx.fill(); ctx.stroke();
    blobShape(ctx, [() => ell(ctx, x, y, r * 1.2, r * 0.85)], F(radial(ctx, x, y, r, "#FDE68A", "#F59E0B")), 2.5);
    ctx.fillStyle = "#1F1308"; [-0.35, 0.15].forEach((k) => ctx.fillRect(x + k * r, y - r * 0.75, r * 0.25, r * 1.5));
    ctx.fillStyle = "#1F1308"; ctx.beginPath(); ctx.moveTo(x + r * 1.15, y - 2); ctx.lineTo(x + r * 1.6, y); ctx.lineTo(x + r * 1.15, y + 2); ctx.fill();
    eyes(ctx, x - r * 0.7, y - r * 0.1, r * 0.22, ang, r * 0.2, true);
  } else if (e.type === "beetle") {
    legsLines(ctx, x, y, r, t * (e.charging ? 2 : 1), 6, "#1F1308");
    blobShape(ctx, [() => ell(ctx, x, y, r * 1.15, r * 0.85)], F(radial(ctx, x, y, r, e.charging ? "#F87171" : "#B45309", e.charging ? "#7F1D1D" : "#451A03")), 2.5);
    ctx.strokeStyle = OUT; ctx.lineWidth = 1.5; ctx.beginPath(); ctx.moveTo(x, y - r * 0.8); ctx.lineTo(x, y + r * 0.8); ctx.stroke();
    ctx.fillStyle = "rgba(255,255,255,0.5)"; ell(ctx, x - r * 0.45, y - r * 0.4, r * 0.25, r * 0.12); ctx.fill();
    const hd = Math.cos(ang) >= 0 ? 1 : -1;
    blobShape(ctx, [() => ell(ctx, x + hd * r * 1.05, y + r * 0.1, r * 0.45, r * 0.4)], F("#292524"), 2);
    ctx.strokeStyle = "#292524"; ctx.lineWidth = 1.5; ctx.beginPath(); ctx.moveTo(x + hd * r * 1.2, y - r * 0.2); ctx.lineTo(x + hd * r * 1.7, y - r * 0.8); ctx.stroke();
    ctx.fillStyle = e.charging ? "#FDE047" : "#fff"; ell(ctx, x + hd * r * 1.2, y, r * 0.12, r * 0.12); ctx.fill();
  } else if (e.type === "crab") {
    legsLines(ctx, x, y, r, t, 6, "#9A3412");
    const snap = Math.sin(t * 6 + (e.seed || 0)) * 0.3;
    [-1, 1].forEach((sd) => {
      blobShape(ctx, [() => ell(ctx, x + sd * r * 1.25, y - r * 0.35, r * 0.42, r * 0.38)], F("#F97316"), 2);
      ctx.fillStyle = "#7C2D12"; ctx.beginPath(); ctx.moveTo(x + sd * r * 1.25, y - r * 0.35); ctx.lineTo(x + sd * r * 1.7, y - r * (0.55 + snap * 0.3)); ctx.lineTo(x + sd * r * 1.7, y - r * 0.2); ctx.fill();
    });
    blobShape(ctx, [() => ell(ctx, x, y, r * 1.05, r * 0.75)], F(radial(ctx, x, y, r, "#FDBA74", "#C2410C")), 2.5);
    ctx.strokeStyle = OUT; ctx.lineWidth = 2; [-0.3, 0.3].forEach((k) => { ctx.beginPath(); ctx.moveTo(x + k * r, y - r * 0.6); ctx.lineTo(x + k * r, y - r * 1.05); ctx.stroke(); });
    eyes(ctx, x, y - r * 1.15, r * 0.3, ang, r * 0.18);
    mouth(ctx, x, y + r * 0.15, r * 0.3, false);
  }
};

const BOSS_EXTRAS = {
  "Crumb King": {
    back: (ctx, r, t) => blobShape(ctx, [() => { ctx.beginPath(); ctx.moveTo(-r * 0.8, -r * 0.4); ctx.quadraticCurveTo(-r * 1.6, r * 0.6, -r * 1.3 + Math.sin(t * 4) * 1.5, r * 1.1); ctx.lineTo(r * 1.3 + Math.sin(t * 4 + 1) * 1.5, r * 1.1); ctx.quadraticCurveTo(r * 1.6, r * 0.6, r * 0.8, -r * 0.4); ctx.closePath(); }], "#B91C1C", 1.2),
    front: (ctx, r) => {
      blobShape(ctx, [() => { ctx.beginPath(); ctx.moveTo(-r * 0.6, -r * 0.85); ctx.lineTo(-r * 0.7, -r * 1.55); ctx.lineTo(-r * 0.3, -r * 1.15); ctx.lineTo(0, -r * 1.7); ctx.lineTo(r * 0.3, -r * 1.15); ctx.lineTo(r * 0.7, -r * 1.55); ctx.lineTo(r * 0.6, -r * 0.85); ctx.closePath(); }], "#FBBF24", 1);
      ctx.fillStyle = "#EF4444"; ell(ctx, 0, -r * 1.05, r * 0.1, r * 0.1); ctx.fill();
    },
  },
  "Jam Kraken": {
    back: (ctx, r, t) => {
      for (let i = 0; i < 5; i++) {
        const a = Math.PI * (0.15 + i * 0.175), wv = Math.sin(t * 4 + i) * r * 0.3;
        const x1 = Math.cos(a) * r * 0.7, y1 = Math.sin(a) * r * 0.6, x2 = Math.cos(a) * r * 1.7 + wv, y2 = Math.sin(a) * r * 1.3 + r * 0.3;
        ctx.lineCap = "round"; ctx.strokeStyle = OUT; ctx.lineWidth = r * 0.36;
        ctx.beginPath(); ctx.moveTo(x1, y1); ctx.quadraticCurveTo((x1 + x2) / 2 - wv, (y1 + y2) / 2, x2, y2); ctx.stroke();
        ctx.strokeStyle = "#9333EA"; ctx.lineWidth = r * 0.24; ctx.stroke();
        ctx.fillStyle = "#E9D5FF"; ell(ctx, x2, y2, r * 0.06, r * 0.06); ctx.fill();
      }
    },
  },
  "Mold Titan": {
    front: (ctx, r) => {
      [[-0.5, -1.05, 0.32, "#DC2626"], [0.15, -1.25, 0.4, "#F97316"], [0.6, -0.95, 0.26, "#DC2626"]].forEach(([dx, dy, s, col]) => {
        ctx.fillStyle = "#FFF7E6"; ctx.fillRect((dx - s * 0.2) * r, dy * r, s * 0.4 * r, s * 0.9 * r);
        blobShape(ctx, [() => { ctx.beginPath(); ctx.ellipse(dx * r, dy * r, s * r, s * 0.7 * r, 0, Math.PI, 0); ctx.closePath(); }], col, 1);
        ctx.fillStyle = "#fff"; ell(ctx, (dx - s * 0.3) * r, (dy - s * 0.35) * r, s * 0.15 * r, s * 0.15 * r); ctx.fill();
      });
    },
  },
  "Burnt Baron": {
    front: (ctx, r) => {
      blobShape(ctx, [() => ell(ctx, 0, -r * 1.1, r * 0.95, r * 0.18), () => rr(ctx, -r * 0.55, -r * 1.95, r * 1.1, r * 0.85, r * 0.12)], "#111827", 1);
      ctx.fillStyle = "#B91C1C"; ctx.fillRect(-r * 0.55, -r * 1.35, r * 1.1, r * 0.18);
      ctx.strokeStyle = "#FBBF24"; ctx.lineWidth = 0.8; ctx.beginPath(); ctx.arc(r * 0.36, -r * 0.2, r * 0.3, 0, Math.PI * 2); ctx.stroke();
      ctx.beginPath(); ctx.moveTo(r * 0.36, r * 0.1); ctx.lineTo(r * 0.5, r * 0.7); ctx.stroke();
    },
  },
};
export const drawBossExtras = (ctx, name, r, t, layer) => BOSS_EXTRAS[name.replace(/ (II|III|IV)$/, "")]?.[layer]?.(ctx, r, t);

export const drawBoss = (ctx, b, t, ang) => {
  const { x } = b, y = b.y + Math.sin(t * 3) * 4;
  shadow(ctx, x, b.y + 46, 38);
  const g = ctx.createLinearGradient(x - 36, y, x + 36, y);
  g.addColorStop(0, "#94A3B8"); g.addColorStop(0.45, "#F8FAFC"); g.addColorStop(1, "#64748B");
  [-1, 1].forEach((sd) => {
    const sw = Math.sin(t * 5 + sd) * 6;
    ctx.lineCap = "round"; ctx.strokeStyle = OUT; ctx.lineWidth = 9;
    ctx.beginPath(); ctx.moveTo(x + sd * 34, y + 2); ctx.quadraticCurveTo(x + sd * 54, y + 12 + sw, x + sd * 50, y + 28 + sw); ctx.stroke();
    ctx.strokeStyle = "#475569"; ctx.lineWidth = 5; ctx.stroke();
    blobShape(ctx, [() => ell(ctx, x + sd * 50, y + 30 + sw, 7, 6)], "#1F2937", 2);
  });
  ctx.fillStyle = "rgba(148,163,184,0.5)";
  for (let i = 0; i < 3; i++) { const k = (t * 0.8 + i / 3) % 1; ell(ctx, x - 20 + i * 18, y - 34 - k * 40, 6 + k * 8, 5 + k * 6); ctx.globalAlpha = 1 - k; ctx.fill(); }
  ctx.globalAlpha = 1;
  blobShape(ctx, [() => rr(ctx, x - 38, y - 28, 76, 58, 16)], b.hitT > 0 ? "#fff" : g, 3.5);
  ctx.fillStyle = "#475569"; rr(ctx, x + 38, y - 8, 8, 18, 3); ctx.fill();
  const glow = b.enraged ? "#EF4444" : "#FB923C";
  ctx.fillStyle = glow; ctx.shadowColor = glow; ctx.shadowBlur = 14;
  rr(ctx, x - 26, y - 30, 20, 6, 3); ctx.fill(); rr(ctx, x + 6, y - 30, 20, 6, 3); ctx.fill();
  ctx.shadowBlur = 0;
  eyes(ctx, x, y - 6, 13, ang, 7, true, "#FECACA");
  ctx.fillStyle = "#1F2937"; rr(ctx, x - 14, y + 12, 28, 7, 3); ctx.fill();
  ctx.fillStyle = "#F8FAFC"; for (let i = 0; i < 4; i++) ctx.fillRect(x - 12 + i * 7, y + 12, 4, 3);
  ctx.fillStyle = "#475569"; [[-32, -22], [32, -22], [-32, 24], [32, 24]].forEach(([dx, dy]) => { ell(ctx, x + dx, y + dy, 2.2, 2.2); ctx.fill(); });
  ctx.fillStyle = "rgba(255,255,255,0.55)"; rr(ctx, x - 30, y - 22, 8, 30, 4); ctx.fill();
  if (b.enraged) { ctx.strokeStyle = "#1F2937"; ctx.lineWidth = 2; ctx.beginPath(); ctx.moveTo(x + 10, y - 26); ctx.lineTo(x + 16, y - 14); ctx.lineTo(x + 12, y - 6); ctx.lineTo(x + 20, y + 4); ctx.stroke(); }
};

export const drawWeapon = (ctx, x, y, ang, w, len) => {
  ctx.save();
  ctx.translate(x, y); ctx.rotate(ang);
  ctx.lineWidth = 2; ctx.strokeStyle = OUT;
  rr(ctx, 8, -3, 10, 6, 3); ctx.fillStyle = "#8B4513"; ctx.fill(); ctx.stroke();
  ctx.fillStyle = w.color;
  if (w.name === "Rolling Pin Maul") {
    rr(ctx, 18, -w.width / 2, len, w.width, w.width / 2); ctx.fill(); ctx.stroke();
    ctx.fillStyle = "#8B4513"; rr(ctx, 16 + len, -3, 8, 6, 3); ctx.fill(); ctx.stroke();
  } else if (w.name === "Whisk Flail") {
    ctx.fillRect(16, -2, len * 0.5, 4);
    ctx.strokeStyle = w.color; ctx.lineWidth = 2.5;
    [-0.5, 0, 0.5].forEach((k) => { ctx.beginPath(); ctx.ellipse(16 + len * 0.75, 0, len * 0.28, 7 + k * 6, 0, 0, Math.PI * 2); ctx.stroke(); });
  } else if (w.name === "Baguette Sword") {
    rr(ctx, 16, -w.width / 2, len, w.width, w.width / 2); ctx.fill(); ctx.stroke();
    ctx.strokeStyle = "#FDE68A"; ctx.lineWidth = 1.5;
    for (let i = 8; i < len - 4; i += 9) { ctx.beginPath(); ctx.moveTo(16 + i, -2); ctx.lineTo(20 + i, 2); ctx.stroke(); }
  } else {
    ctx.beginPath(); ctx.moveTo(16, -w.width / 2); ctx.lineTo(16 + len, -w.width / 2); ctx.quadraticCurveTo(20 + len, 0, 16 + len, w.width / 2); ctx.lineTo(16, w.width / 2); ctx.closePath();
    ctx.fill(); ctx.stroke();
    if (w.name === "Dinner Fork") [-4, 0, 4].forEach((o) => { ctx.fillRect(16 + len, o - 1, 8, 2); });
    if (w.name === "Golden Spatula") { rr(ctx, 14 + len, -9, 14, 18, 3); ctx.fill(); ctx.stroke(); }
  }
  ctx.fillStyle = "rgba(255,255,255,0.55)"; ctx.fillRect(18, -w.width / 2 + 1, len * 0.6, 1.5);
  ctx.restore();
};
